import useAuth from "hooks/UseAuth";
import { useHistory, useLocation } from "react-router";

import { ReactComponent as BellIcon } from 'assets/icons/bell.svg';
import person_coin from 'assets/icons/person_coin.svg';
import white_chevron_down from 'assets/icons/white_chevron_down.svg';
import DefaultProfile from 'assets/img/default-profile-image.png'

import Instagram from 'assets/icons/sidebar/Instagram.png';
import Facebook from 'assets/icons/sidebar/Facebook.png';
import LinkedIn from 'assets/icons/sidebar/linkedin.png';
import Youtube from 'assets/icons/sidebar/Youtube.png';
import Twitter from 'assets/icons/sidebar/twitter.png';

import { Container, SignInSelect } from "./_userBox"
import { Link } from "react-router-dom";
import { useOutside } from "hooks/UseOutside";
import { useRef, useState } from "react";
import { NotificationBell } from "../NotificationBell/NotificationBell";

export const UserBox = () => {
  const location = useLocation()
  const { pathname } = location;

  const history = useHistory();
  const { user, signOut } = useAuth();

  const ref = useRef(null)

  const [isOpen, setIsOpen] = useState(false)

  const auth = + !!user?.id;

  const handleSignin = () => {
    history.push('/login');
  }

  const handleSignout = async () => {
    await signOut();

    history.push('/login');
  }

  const content = [
    {action: 'login', avatar_url: person_coin, onClick: handleSignin},
    {action: 'sair', avatar_url: user?.avatar_url, onClick: handleSignout}
  ]

  const toggleMenu = () => {
    setIsOpen(prevState => !prevState)
  }

  const closeMenu = () => {
    if (isOpen) {
      setIsOpen(false)
    }
  }

  useOutside(ref, closeMenu)

  return (
    <Container pathname={pathname} ref={ref}>
      {/* <div className="user-box__bell-container">
        <BellIcon />
      </div> */}
      <NotificationBell pathname={pathname} />
      <div className="user-box-wrapper">
        <SignInSelect>
          <button
            type="button"
            className="signin-select__profile-wrapper"
            onClick={content[auth]?.onClick}
          >
            <img
              className="signin-select__profile-icon"
              src={content[auth]?.avatar_url}
              alt="Ícone de perfil"
              onError={
                (event: React.ChangeEvent<HTMLImageElement>) => {
                  event.target.src = DefaultProfile
                }
              }
            />
            <span
              className="signin-select__profile-action"
            >
              {content[auth]?.action}
            </span>
          </button>
          <hr className="signin-select__profile-divider" />
          <button
            className="signin-select__chevron-button"
            type="button"
            onClick={toggleMenu}
          >
            <img
              className="signin-select__chevron-icon"
              src={white_chevron_down}
              alt="Opções"
            />
          </button>
          <div className={isOpen ? "user-box__menu" :  'menu--closed'}>
            <Link to="/quem-somos" className="user-box__menu-link">
              Quem somos
            </Link>
            <Link to="/como-funciona" className="user-box__menu-link">
              Como funciona?
            </Link>
            <a
              href="https://www.repfy.com.br/"
              className="user-box__menu-link"
              target="_blank"
              rel="noreferrer"
            >
              Visitar nosso site
            </a>
            <Link to="/suporte" className="user-box__menu-link">
              Suporte
            </Link>
            <button
              type="button"
              className="user-box__menu-exit"
              onClick={content[auth]?.onClick}
            >
              <span
                className="user-box__menu-exit-text"
              >
                {content[auth]?.action}
              </span>
            </button>
            <div className="user-box__social-container">
              <a
                href="https://www.youtube.com/channel/UC4QwUrsphMc3oJVuDm_5YDA"
                className="user-box__menu-social"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="user-box__social-img"
                  src={Youtube}
                  alt="Youtube"
                />
              </a>
              <a
                href="https://www.facebook.com/repfyapp"
                className="user-box__menu-social"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="user-box__social-img"
                  src={Facebook}
                  alt="Facebook"
                />
              </a>
              <a
                href="https://www.Instagram.com/repfyapp"
                className="user-box__menu-social"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="user-box__social-img"
                  src={Instagram}
                  alt="Instagram"
                />
              </a>
              <a
                href="https://linkedin.com/company/repfy"
                className="user-box__menu-social"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="user-box__social-img"
                  src={LinkedIn}
                  alt="LinkedIn"
                />
              </a>
              <a
                href="https://twitter.com/repfy_app"
                className="user-box__menu-social"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="user-box__social-img"
                  src={Twitter}
                  alt="Twitter"
                />
              </a>
            </div>
          </div>
        </SignInSelect>
      </div>
    </Container>
  )
}
